export default __webpack_public_path__ + "static/media/undefinedThumbnail.9b6d5f02.png";